import React from 'react'
import styled from 'styled-components'

import circle from 'assets/images/png/icon-circle-pencil.png'
import note from 'assets/images/svg/icon-note.svg'

const ListImage = ({
  listText,
  type,
  noteText,
  image,
  font,
  fontList,
  noteText1,
  icon
}) => {
  return type === 'list' ? (
    <Container font={fontList}>
      <img src={image ? image : circle} alt='icon circle' loading="lazy"/>
      {listText}
    </Container>
  ) : (
    <Note font={font} icon={icon}>
     {icon != "no"&& <img src={note} alt='icon circle' loading="lazy"/>}
      {noteText}
      {noteText1 && (
        <>
          <br />
          {noteText1}
        </>
      )}
    </Note>
  )
}

export default ListImage

const Container = styled.div`
  display: flex;
  width: 100%;
  font-family: ${(props) => (props.font ? props.font : 'Noto Sans Thai')};
  line-height: 40px;
  font-size: ${(props) => (props.font ? 'clamp(20px, 2.5vw, 24px)' : 'clamp(18px, 2.5vw, 24px)')};

  text-align: left;
  margin-bottom: 20px;
  align-items: center;

  img {
    height: 85px;
    margin-right: 35px;
  }

  @media only screen and (max-width: 414px) {
    img {
      height: 60px;
      margin-right: 20px;
    }
  }
`

const Note = styled.div`
  display: flex;
  align-items: center;
  width: ${(props) => (props.icon == "no" ? "auto" : "100%")};
  font-family: ${(props) => (props.font ? props.font : 'Noto Sans Thai')};
  line-height: 30px;
  font-size: 18px;
  text-align: left;
  margin-bottom: 20px;

  margin-right: ${(props) => (props.icon == "no" ? "30px" : "0")};
  margin-left: ${(props) => (props.icon == "no" ? "110px" : "0")};


  img {
    height: 50px;
    margin-right: 30px;
    margin-left: 10px;
  }
`
